<template>
  <div>
    <b-carousel
      id="header-carousel"
      controls
      indicators
      fade
      :interval="10000"
      v-model="slide"
      ref="carousel"
      @sliding-start="onSlideStart"
      @sliding-end="onSlideEnd"
      class="header-carousel"
    >
      <b-carousel-slide v-for="(game,index) in bannerGames" :key="index">
        <template v-slot:img>
          <div class="header-content d-block" :class="{ 'header-content-slide': game.slidingLogo}">
            <img :src="'/images/logo-'+game.id+ ($i18n.locale == 'en' ? '-en' : '') +'.png'" class="header-content-img" />
            <b-button
              variant="danger"
              class="header-content-button rounded-0"
              :href="game.link"
              target="_blank"
            >{{$t('home.more')}}</b-button>
          </div>
          <div class="d-flex justify-content-center header-img-warpper">
            <!-- <img
              :src="'/images/header-'+game.id+'.png'"
              class="header-img d-block"
              :class="{ 'header-img-slide': game.sliding, 'header-img-slide-slow': game.slidingSlow}"
              @transitionend="onFadein"
            /> -->
            <div
              :style="{ backgroundImage: 'linear-gradient(to right, black, transparent, black), url(/images/header-'+game.id+'.png)' , backgroundPosition: 'center', backgroundSize: 'cover'}"
              class="header-img d-block"
              :class="{ 'header-img-slide': game.sliding, 'header-img-slide-slow': game.slidingSlow}"
              @transitionend="onFadein"
            />
          </div>
        </template>
      </b-carousel-slide>
    </b-carousel>
    <div class="games">
      <div class="games-container text-white">
        <div class="games-title">
          <h2 class="d-inline-flex">{{$t('home.games')}}</h2>
          <!-- <b-link class="ml-3 text-danger">
            {{$t('home.games_all')}}
            <font-awesome-icon :icon="['fas', 'chevron-right']" />
          </b-link> -->
        </div>
        <div class="games-labels-warpper" ref="games">
          <div class="games-labels">
            <div
              v-for="(game,index) in games"
              :key="index"
              :alt="game.name"
              class="games-label-warpper"
              :class="{'games-label-warpper-last': index==4}"
            >
              <div class="games-label" :style="{ backgroundImage: 'url(/images/label-'+game.id + ($i18n.locale == 'en' ? '-en' : '') +'.png)', backgroundSize: 'cover'}"></div>
              <div class="games-label-overlay d-flex justify-content-center align-items-start">
                <b-button variant="danger" class="rounded-0 w-75 mt-4" :href="game.link" target="_blank">{{$t('home.explore')}}</b-button>
              </div>
            </div>
          </div>
          <div class="games-angle games-angle-left" @click.prevent="onGames('right')">
            <font-awesome-icon :icon="['fas', 'angle-left']" size="2x"/>
          </div>
          <div class="games-angle games-angle-right" @click.prevent="onGames('left')">
            <font-awesome-icon :icon="['fas', 'angle-right']" size="2x"/>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="awards" :style="awardsStyle">
      <div class="awards-container text-white">
        <div class="awards-title">
          <h2>{{$t('home.awards')}}</h2>
        </div>
      </div>
    </div> -->
    <!-- <div class="news">
      <div class="games-container">
        <div class="news-title text-white">
          <h2 class="d-inline-flex">{{$t('home.news')}}</h2>
          <b-link class="ml-3 text-danger" :to="$t('nav.menu')[0].to">
            {{$t('home.news_all')}}
            <font-awesome-icon :icon="['fas', 'chevron-right']" />
          </b-link>
        </div>
        <div class="news-cards-warpper" ref="cards">
          <div class="news-cards">
            <b-link
              v-for="(news,index) in $t('news')"
              :key="index"
              :to="{ name:'blog',params: {link: news.link, height: news.height }}"
              target="_self">
              <b-card
                class="rounded-0 news-card"
                no-body
                text-variant="white"
                sub-title-text-variant="danger"
              >
                <div class="news-card-img-warpper">
                  <b-card-img :src="news.cover" class="rounded-0 news-card-img"></b-card-img>
                </div>
                <b-card-body>
                  <b-card-sub-title>{{news.type}}</b-card-sub-title>
                  <b-card-title title-tag="h5" style="white-space: normal;">{{news.title}}</b-card-title>
                </b-card-body>
              </b-card>
            </b-link>
          </div>
        </div>
      </div>
    </div> -->
    <div class="join-us">
      <div class="join-us-container text-white">
        <h1 class="join-us-title">{{$t('home.join_us')}}</h1>
          <br />
          <br />
          <h4 class="join-us-text mt-lg-5">
            <!-- {{$t('home.join_us_des')}}
            <br />
            {{$t('home.join_us_des2')}}
            <br /> -->
            {{$t('home.join_us_des3')}}
          </h4>
          <br />
        <b-button squared class variant="danger" href="mailto:careers@multiverseinc.com">{{$t('home.join_us_btn')}}</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import Bscroll from 'better-scroll';
export default {
  data() {
    return {
      games: this.$t("games"),
      slide: 0,
      sliding: null,
    };
  },
  computed:{
    bannerGames(){
      let games = this.games.filter((v)=>{
        return v.id!="sdlbe";
      });
      return games;
    },
    awardsStyle(){
      let mobile = window.innerWidth>992 ? '' : '-m';
      return { 'background-image' : 'url(/images/awards-'+this.$i18n.locale+mobile+'.png)'}
    }
  },
  mounted() {
    for (let i = 0; i < this.games.length; i++) {
      this.$set(this.games[i], "sliding", false);
      this.$set(this.games[i], "slidingSlow", false);
      this.$set(this.games[i], "slidingLogo", false);
    }
    this.$refs.carousel.next();
    this.$nextTick(() => {
      this.scroll = new Bscroll(this.$refs.games,
        {startX: 0,
        click: true,
        scrollX: true,
        scrollY: false,
        })

      this.scrollGames = new Bscroll(this.$refs.cards,
        {startX: 0,
        click: true,
        scrollX: true,
        scrollY: false,
        })
    })
  },
  methods: {
    onSlideStart(slide) {
      this.sliding = true;
      this.games[slide].sliding = true;
    },
    onSlideEnd(slide) {
      this.sliding = false;
      for (let i = 0; i < this.games.length; i++) {
        if (i !== slide) {
          this.games[i].sliding = false;
          this.games[i].slidingSlow = false;
          this.games[i].slidingLogo = false;
        }
      }
    },
    onFadein(event) {
      if (event.elapsedTime === 1) {
        this.games[this.slide].slidingSlow = true;
        this.games[this.slide].slidingLogo = true;
      }
    },
    onGames(direction){
      if(direction == "left"){
        this.scroll.scrollBy(-200, 0, 500);
      }
      else {
        this.scroll.scrollBy(200, 0, 500);
      }
    },
    onNews(direction){
      if(direction == "left"){
        this.scrollGames.scrollBy(-200, 0, 500);
      }
      else {
        this.scrollGames.scrollBy(200, 0, 500);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.header-img {
  position: relative;
  height: 450px;
  width: 100%;
  transition: transform 1s linear;
  transform: translate(2%, 0);
  &-warpper {
    background: black;
  }
  &-slide {
    transform: translate(1%, 0);
  }
  &-slide-slow {
    transform: translate(-1%, 0);
    transition: transform 8s linear;
  }
}

.header-content {
  position: absolute;
  z-index: 100;
  top: 15rem;
  left: 0;
  right: 0;
  padding: 0 1.2rem;
  opacity: 0;
  transition: transform 1s, opacity 1s;
  text-align: center;
  &-slide {
    transform: translate(0, 0);
    opacity: 1;
  }
  &-img{
    max-width: 20rem;
    max-height: 10rem;
    object-fit: contain;
  }
  &-button {
    display: inline-block;
    margin-top: 2rem;
    width: 100%;
  }
}

.games {
  padding: 2.5rem 0;
  background-image: url('./images/games-bg.png');
  background-size: cover;
  background-position: center;
  &-container {
    max-width: 100rem;
    margin: auto;
    padding-left: 1.2rem;
    padding-right: 1.2rem;
  }
  &-title {
    margin-top: 0;
    margin-bottom: 2rem;
    padding-left: 0%;
  }
  &-labels {
    width: 49rem;
    &-warpper{
      margin-top: 1.9rem;
      margin-bottom: 2rem;
      overflow: hidden;
    }
  }
  &-label {
    width: 100%;
    background-size: cover;
    background-position: center;
    transition: all .5s cubic-bezier(0,0,0,1.15);
    width: 100%;
    height: 100%;
    &:hover{
      transform: scale(1.05);
    }
    &-warpper{
      width: 8.75rem;
      height: 11.25rem;
      position: relative;
      display: inline-block;
      overflow: hidden;
      margin-right: 1rem;
      &-last{
        margin-right: 0rem;
      }
    }
    &-overlay{
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      border: solid 1px $custom-red;
      background-color: $custom-red-cover;
      opacity: 0;
      transition: all .5s cubic-bezier(0,0,0,1.15);
      &:hover{
        opacity: 1;
      }
    }
  }

  &-angle{
    display:none;
  }
}

.awards{
  padding: 2.5rem 0;
  &-container{
    max-width: 100rem;
    margin: auto;
    padding-left: 1.2rem;
    padding-right: 1.2rem;
  }
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin: 0 auto;
  &::after{
    content: "";
    display: block;
    /*这里的padding =  height / width*/
    padding-bottom: 100%;
  }
}

.news {
  padding: 2.5rem 0;
  background-image: url('./images/news-bg.png');
  background-size: cover;
  background-position: center;
  &-container {
    max-width: 100rem;
    margin: auto;
    padding-left: 1.2rem;
    padding-right: 1.2rem;
  }
  &-title {
    margin-top: 0;
    margin-bottom: 0;
    padding-left: 0%;
  }
  &-cards {
    width: 44.3rem;
    white-space: nowrap;
    &-warpper{
      margin-top: 0;
      margin-bottom: 2rem;
      overflow: hidden;
    }
  }
  &-card {
    width: 225px;
    height: 190px;
    position: relative;
    display: inline-block;
    overflow: hidden;
    margin-right: 1rem;
    background-color: #268cb6;
    &:hover{
      background-color: #3bb7ea;
    }
  }
  .card-body{
    padding: 10px 15px;
  }
  .card-subtitle{
    font-size: 0.75rem;
    color: rgba(255,255,255,0.6) !important;
  }
  .card-title{
    font-size: 0.85rem;
  }
}

.join-us{
  padding: 5rem 0 0;
  background-image: url('./images/join-us-bg.png');
  background-size: cover;
  background-position: top;
  height: 330px;
  &-container{
    max-width: 100rem;
    margin: auto;
    padding-left: 2.5rem;
    padding-right: 2.5rem;
    text-align: center;
  }
  &-title {
    font-size: 1.7rem;
  }
  &-text {
    font-size: 1.1rem;
    white-space: pre-line
  }
}

@include media-breakpoint-up(lg) {
  h2 {
    font-size: 2.2rem;
  }
  .header-img {
    position: relative;
    height: 613px;
    width: 2000px;
    transition: transform 1s linear;
    transform: translate(2%, 0);
    &-warpper {
      background: black;
    }
    &-slide {
      transform: translate(1%, 0);
    }
    &-slide-slow {
      transform: translate(-1%, 0);
      transition: transform 8s linear;
    }
  }
  .header-content {
    position: absolute;
    z-index: 100;
    top: 15rem;
    left: 0;
    right: 0;
    padding: 0 2.5rem;
    opacity: 0;
    transition: transform 1s, opacity 1s;
    text-align: left;
    max-width: 100rem;
    margin: auto;
    &-slide {
      transform: translate(0, 0);
      opacity: 1;
    }
    &-img{
      width: 30rem;
    }
    &-button {
      display: block;
      width: 12rem;
      margin-top: 2rem;
      transform: translate(0,0);
    }
  }
  .games {
    padding: 5rem 0;
    background-image: url('./images/games-bg.png');
    background-size: cover;
    background-position: center;
    &-title {
      margin-top: 2rem;
      margin-bottom: 2rem;
      padding-left: 0%;
    }

    &-container {
      max-width: 100rem;
      margin: auto;
      padding-left: 2.5rem;
      padding-right: 2.5rem;
    }
    &-labels {
      width: 95rem;
      &-warpper{
        margin-top: 1.9rem;
        margin-bottom: 2rem;
        overflow: hidden;
        position: relative;
      }
    }
    &-label {
      width: 100%;
      // border: solid 10px rgba(255, 255, 255, 0.15);
      background-size: cover;
      background-position: center;
      transition: all .5s cubic-bezier(0,0,0,1.15);
      width: 100%;
      height: 100%;
      &:hover{
        transform: scale(1.05);
      }
      &-warpper{
        width: 17.625rem;
        height: 20.625rem;
        position: relative;
        display: inline-block;
        overflow: hidden;
        margin-right: 1.71875rem;
        &-last{
          margin-right: 0rem;
        }
      }
      &-overlay{
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        border: solid 1px $custom-red;
        background-color: $custom-red-cover;
        opacity: 0;
        transition: all .5s cubic-bezier(0,0,0,1.15);
        &:hover{
          opacity: 1;
        }
      }
    }
    @media screen and (max-width: 1620px) {
      &-angle{
        position: absolute;
        top: 8rem;
        bottom: 8rem;
        width: 2rem;
        background-color: $custom-red;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: all .5s cubic-bezier(0,0,0,1.15);
        cursor: pointer;
        &:hover{
          background-color: $custom-red-active;
        }
        &-left{
          left: 2rem;
        }
        &-right{
          right: 2rem;
        }
      }
    }
  }

  .news {
    padding: 5rem 0;
    background-image: url('./images/news-bg.png');
    background-size: cover;
    background-position: center;
    &-container {
      max-width: 100rem;
      margin: auto;
      padding-left: 1.2rem;
      padding-right: 1.2rem;
    }
    &-title {
      margin-top: 2rem;
      margin-bottom: 2rem;
      padding-left: 0%;
    }
    &-cards {
      width: 94rem;
      white-space: nowrap;
      &-warpper{
        margin-top: 0;
        margin-bottom: 2rem;
        overflow: hidden;
        position: relative;
      }
    }
    &-card {
      width: 30rem;
      height: 27rem;
      position: relative;
      display: inline-block;
      overflow: hidden;
      margin-right: 1.8rem;
      transition: all .5s cubic-bezier(0,0,0,1.15);
      &:hover{
        border: solid 1px $custom-red;
      }
      &:hover &-img{
        transform: scale(1.05);
      }
      &-img {
        transition: all .5s cubic-bezier(0,0,0,1.15);
        &-warpper{
          overflow: hidden;
        }
      }
    }
    .card-body{
      padding: 2rem;
    }
    .card-subtitle{
      font-size: 0.9rem;
    }
    .card-title{
      font-size: 1.2rem;
      font-weight: 700;
      // text-shadow: 4px 4px 10px rgba(0, 0, 0, 0.6);
    }
  }

  .awards{
    padding: 5rem 0;
    &-container{
      max-width: 100rem;
      margin: auto;
      padding-left: 2.5rem;
      padding-right: 2.5rem;
    }
    &::after{
      padding-bottom: 20%;
    }
  }

  .join-us{
    padding: 5rem 0;
    background-image: url('./images/join-us-bg.png');
    background-size: cover;
    background-position: top;
    height: 530px;
    &-container{
      max-width: 100rem;
      margin: auto;
      padding-left: 2.5rem;
      padding-right: 2.5rem;
      text-align: left;
    }
    &-title {
      font-size: 2.75rem;
    }
    &-text {
      font-size: 1.6rem;
    }
  }
}
</style>
